import { render, staticRenderFns } from "./contest-info.vue?vue&type=template&id=09db8da6&scoped=true"
import script from "./contest-info.vue?vue&type=script&lang=js"
export * from "./contest-info.vue?vue&type=script&lang=js"
import style0 from "./contest-info.vue?vue&type=style&index=0&id=09db8da6&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09db8da6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/frontend_coduck_manage_sbGx/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('09db8da6')) {
      api.createRecord('09db8da6', component.options)
    } else {
      api.reload('09db8da6', component.options)
    }
    module.hot.accept("./contest-info.vue?vue&type=template&id=09db8da6&scoped=true", function () {
      api.rerender('09db8da6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/research/detail-pane/contest-info.vue"
export default component.exports